import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import SpaceService from "../../../../services/reservations/SpaceService";

export const REQUEST_UPDATE_RATE_PRICE = "REQUEST_UPDATE_RATE_PRICE";
export const UPDATE_RATE_PRICE_SUCCESS = "UPDATE_RATE_PRICE_SUCCESS";
export const UPDATE_RATE_PRICE_ERROR = "UPDATE_RATE_PRICE_ERROR";

function requestUpdateRatePrice() {
  return {
    type: REQUEST_UPDATE_RATE_PRICE,
  };
}

function updateRatePriceSuccess(json) {
  return {
    type: UPDATE_RATE_PRICE_SUCCESS,
    message: json.data,
  };
}

function updateRatePriceError(json) {
  return {
    type: UPDATE_RATE_PRICE_ERROR,
    error: json.data,
  };
}

export function updateBookingAndDeleteSpacePrices(booking_id, bookingData, reservation_id) {
  return (dispatch) => {
    dispatch(requestUpdateRatePrice());
    return SpaceService.updateBookingAndDeleteSpacePrices(booking_id, bookingData, reservation_id).then((json) => {
      if (json.data.code === 200) {
        dispatch(updateRatePriceSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(updateBookingAndDeleteSpacePrices(booking_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(updateRatePriceError(json.data));
      }
    });
  };
}
